import * as lodash from "lodash";
import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";

import { ROUTE_REDIRECT_VALS } from "@tci/common";
import { NgAuthGuardService } from "./ng-shared/ng-services/ng-auth-guard.service";
import { NgAppListComponent } from "./ng-app-list/ng-app-list.component";
import { DummyComponent, TciAppDetailsTenantRouteActivatorFactory } from "./ng-app-list/ng-app-list.module";

@NgModule({
    imports: [
        RouterModule.forRoot(NgAppRoutingModule.getNg2RoutesFromMicroservices(), {
            useHash: false,
            initialNavigation: true,
            enableTracing: false
        })
    ],
    exports: [
        RouterModule
    ]
})
export class NgAppRoutingModule {

    /**
     * Use routes found by loadMicroservicesUI
     * from ng2 moduleConfig.json files
     */
    public static getNg2RoutesFromMicroservices(): Route[] {
        let routes: Route[] = [
            {
                path: "",
                canActivate: [
                    NgAuthGuardService
                ],
                pathMatch: "full",
                redirectTo: "applications"
            },

            // IPAS-13530
            {
                path: ROUTE_REDIRECT_VALS.API_SPECS_ROUTE,
                component: DummyComponent,
                canActivate: [
                    NgAuthGuardService
                ],
                resolve: {
                    url: ROUTE_REDIRECT_VALS.API_SPECS_RESOLVER
                }
            },

            {
                path: "applications",
                component: NgAppListComponent,
                resolve: { // IPAS-13530
                    url: ROUTE_REDIRECT_VALS.API_SPECS_RESOLVER
                },
                canActivate: [
                    NgAuthGuardService
                ],
                children: [
                    {
                        path: ":routeid/:inputid",
                        component: DummyComponent,
                        canActivate: [
                            NgAuthGuardService,
                            TciAppDetailsTenantRouteActivatorFactory
                        ]
                    },
                    {
                        path: "**",
                        redirectTo: "applications"
                    }
                ]
            }
        ];

        if ((<any>window).ng2Routes && (<any>window).ng2Routes.length > 0) {
            routes = routes.concat(lodash.map((<any>window).ng2Routes, NgAppRoutingModule.guardRoute));
        }

        return routes;
    }

    private static guardRoute(route: Route) {
        if (lodash.isArray(route.canActivate)) {
            route.canActivate.push(NgAuthGuardService);
        } else {
            route.canActivate = [
                NgAuthGuardService
            ];
        }
        /**
         * This was removed for the module not to await
         * for tenant modules
         */
        // route.resolve = {
        //     ITCITenantCompCache: TciTenantResolver
        // };
        return route;
    }
}
